var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFormidlingscenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "5.5mm",
    height: "5.5mm",
    viewBox: "0 0 15.591 15.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 15.591,
    height: 15.591,
    rx: 7.795,
    fill: "#021e3a"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.307,6.988,7.982,2.631a.294.294,0,0,0-.373,0L2.283,6.988a.172.172,0,0,0,.109.3H3.784v5.534a.2.2,0,0,0,.2.2h7.623a.2.2,0,0,0,.2-.2V7.293H13.2A.172.172,0,0,0,13.307,6.988ZM10.3,10.478a1.868,1.868,0,0,1-1.856-.147,2.572,2.572,0,0,1-.628.085A2.051,2.051,0,0,1,5.6,8.572,2.052,2.052,0,0,1,7.812,6.728a2.052,2.052,0,0,1,2.21,1.844,1.661,1.661,0,0,1-.5,1.169l0,0a2.377,2.377,0,0,0,.783.653c.043.019.082.022.082.045S10.383,10.458,10.3,10.478Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormidlingscenter);
export default __webpack_public_path__ + "static/media/FORMIDLINGSCENTER.817def708f989cb3016fb7449bf6fa8b.svg";
export { ForwardRef as ReactComponent };